import React from 'react';
import './JournalStartModal.css';

const JournalStartModal = ({ isOpen, onBegin, onCancel, title, message, estimatedTime }) => {
    if (!isOpen) return null;

    return (
        <div className="journal-start-modal-overlay">
            <div className="journal-start-modal">
                <div className="journal-start-modal-header">
                    <h2>{title}</h2>
                </div>

                <div className="journal-start-modal-content">
                    <div className="journal-start-icon">⏱️</div>

                    <div className="journal-start-message">
                        {message.split('\n').map((line, index) => (
                            <p key={index}>{line}</p>
                        ))}
                    </div>

                    {estimatedTime && (
                        <div className="journal-start-time">
                            <strong>Estimated Time:</strong> {estimatedTime}
                        </div>
                    )}

                    {/*
                    <div className="journal-start-warning">
                        <div className="warning-icon">⚠️</div>
                        <p>
                            <strong>Important:</strong> You have 7 days to complete this section before your entry
is locked in. No edits can be made after this period.
                        </p>
                    </div>
                    */}
                </div>

                <div className="journal-start-modal-actions">
                    <button
                        className="btn-cancel"
                        onClick={onCancel}
                        type="button"
                    >
                        Not Now
                    </button>
                    <button
                        className="btn-begin"
                        onClick={onBegin}
                        type="button"
                    >
                        Begin
                    </button>
                </div>
            </div>
        </div>
    );
};

export default JournalStartModal;
